import React, { useState } from 'react'
import { motion } from "framer-motion"
import MenuItem from './sceneList/menuItem'

const SceneList = ({remove = false, actualScene, scenes, expanded = true, variation = "right", title = "", ...props }) => {


    const ListTopVariants = { hidden: { rotate: 90 }, visible: { rotate: 0 } }
    const ItemShowVariants = {
        hidden: i => ({
            opacity: 0, transition: {
                delay: 0,
            },
            transitionEnd: {
                display: "none",
              },
        }), visible: i => ({
            display : "flex",
            opacity: 100, transition: {
                delay: i * 0.1,
            }
        })
    }
    const [extended, setextended] = useState(expanded)

    let z = -1;

    const ico_menu = <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="white" className="" viewBox="0 0 16 16">
        <path d="M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
    </svg>
    return (
        <motion.div animate={extended ? "visible" : "hidden"} {...props}>
            <div className={`flex flex-row gap-2 items-stretch ${variation === "left"? "justify-end":""}`} onClick={() => {
                setextended((prev) => {
                    return !prev;
                })
            }}>

                {variation === "right" ?
                    <>
                        <motion.div transition={{ rotate: { duration: .3 } }} className='bg-gray-800 p-1 rounded-md' variants={ListTopVariants}>
                            {ico_menu}
                        </motion.div>
                        <div className='rounded-md text-lg font-bold bg-gray-800  px-5 text-white flex items-center'>
                            {title}
                        </div>
                    </>
                    :
                    <>
                        <div className='rounded-md text-lg font-bold bg-gray-800  px-5 text-white flex items-center'>
                            {title}
                        </div>
                        <motion.div transition={{ rotate: { duration: .3 } }} className='bg-gray-800 p-1 rounded-md' variants={ListTopVariants}>
                            {ico_menu}
                        </motion.div>
                    </>
                }



            </div>
            {

                scenes.map((x, i) => {
                    if (remove) {
                        return;
                    }



                    z += 1;
                    return (
                        <MenuItem variation={variation} initial={extended ? { opacity: 1 } : { opacity: 0 }} scene={x} custom={z} key={i} variants={ItemShowVariants} />
                    );

                })
            }


        </motion.div>
    )
}

export default SceneList

